import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
/**
 * Wrap any Custom Component and make it
 * hoverable, also adding the hover color effect
 * when hovered.
 *
 * Use case check Svg on Toolkit Panel
 **/
const isHoverable = (WrappedComponent) =>
  // TODO is there a better place to put this component
  class extends PureComponent {
    static defaultProps = {
      disableHover: false,
      color: '#1E1E1E',
      hoverColor: '#0077C8',
    };

    static propTypes = {
      /* disable to useHover functionality */
      disableHover: PropTypes.bool,
      /* default component color */
      color: PropTypes.string,
      /* the new color to apply when hovered */
      hoverColor: PropTypes.string,
    };

    constructor(props) {
      super(props);
      this.state = {
        color: props.color,
      };
    }

    changeColor = (hovered) => {
      const { disableHover, hoverColor, color } = this.props;
      if (!disableHover) {
        this.setState({
          color: hovered ? hoverColor : color,
        });
      }
    };

    render() {
      const { accessibility, ...otherProps } = this.props;

      return (
        <div style={{ cursor: 'pointer', display: 'flex' }}>
          <WrappedComponent
            color={this.state.color}
            {...otherProps}
            {...accessibility}
            onMouseLeave={() => this.changeColor(false)}
            onMouseEnter={() => this.changeColor(true)}
          />
        </div>
      );
    }
  };

export default isHoverable;
